import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  flex 
  app-container 
  mt-10 
  gap-[100px]
`);
